import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
export default class ObservationSlideoverService extends Service {
  @tracked isOpen = true;

  @action
  setIsOpen(e: boolean) {
    this.isOpen = e;
  }
}

// Don't remove this declaration: this is what enables TypeScript to resolve
// this service using `Owner.lookup('service:observation-slideover')`, as well
// as to check when you pass the service name as an argument to the decorator,
// like `@service('observation-slideover') declare altName: ObservationSlideoverService;`.
declare module '@ember/service' {
  interface Registry {
    'observation-slideover': ObservationSlideoverService;
  }
}
